module.exports = __webpack_public_path__ + "media/images/empty-06c805d5f8d0f0cd4e449c4c671db2b6.png";